// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"86d462c6","515":"3bc0ee28"}[chunkId] + ".chunk.css";
};